import { render, staticRenderFns } from "./monthly_area_compare.vue?vue&type=template&id=fc10b5e2&scoped=true"
import script from "./monthly_area_compare.vue?vue&type=script&lang=js"
export * from "./monthly_area_compare.vue?vue&type=script&lang=js"
import style0 from "./monthly_area_compare.vue?vue&type=style&index=0&id=fc10b5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc10b5e2",
  null
  
)

export default component.exports